export default {
  mut_user (st, data) {
    st.user = data
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js